{
  "name": "Hyview",
  "slug": "hyview",
  "version": "1.0.0",
  "brandColor": "#ffc400",
  "icon": {
    "backgroundColor": "#1c1a1f"
  },
  "splash": {
    "backgroundColor": "#1c1a1f"
  },
  "assets": {
    "icon": "./src/flavors/hyview/assets/images/icon.png",
    "iconSplash": "./src/flavors/hyview/assets/images/icon-splash.png",
    "iconLarge": "./src/flavors/hyview/assets/images/icon-large.png",
    "iconSmall": "./src/flavors/hyview/assets/images/icon-small.png",
    "iconSmall2x": "./src/flavors/hyview/assets/images/icon-small2x.png",
    "adaptiveIconForeground": "./src/flavors/hyview/assets/images/adaptive-icon-foreground.png",
    "adaptiveIconBackground": "",
    "topShelf": "./src/flavors/hyview/assets/images/top-shelf.png",
    "topShelf2x": "./src/flavors/hyview/assets/images/top-shelf2x.png",
    "topShelfWide": "./src/flavors/hyview/assets/images/top-shelf-wide.png",
    "topShelfWide2x": "./src/flavors/hyview/assets/images/top-shelf-wide2x.png",
    "banner": "./src/flavors/hyview/assets/images/banner.png",
    "favicon": "./src/flavors/hyview/assets/images/favicon.png"
  },
  "fonts": [
    "./src/flavors/hyview/assets/fonts/Rubik-Regular.ttf",
    "./src/flavors/hyview/assets/fonts/Rubik-Medium.ttf"
  ],
  "icons": {
    "input": "./src/flavors/hyview/assets/icons",
    "output": "./src/flavors/hyview/assets/icons/generated"
  },
  "locales": {
    "en": {
      "ios": {
        "NSLocalNetworkUsageDescription": "This app uses the local network to discover Cast-enabled devices on your WiFi network.",
        "NSBluetoothAlwaysUsageDescription": "Bluetooth may be used together with the local network to discover nearby TVs and casting devices when you connect or cast.",
        "NSPhotoLibraryUsageDescription": "Access is only requested if you choose to save an image from the app to your photo library."
      },
      "tvos": {
        "NSLocalNetworkUsageDescription": "This TV advertises itself on the local network so the companion app can discover it for pairing.",
        "NSBluetoothAlwaysUsageDescription": "Bluetooth may be used together with the local network to discover nearby TVs and casting devices when you connect or cast.",
        "NSPhotoLibraryUsageDescription": "This app may access your photo library to display images you open or share."
      }
    },
    "nl": {
      "ios": {
        "NSLocalNetworkUsageDescription": "Deze app gebruikt het lokale netwerk om Cast-in staat zijnde apparaten op je WiFi-netwerk te ontdekken.",
        "NSBluetoothAlwaysUsageDescription": "Bluetooth kan worden gebruikt in combinatie met het lokale netwerk om nabijgelegen televisies en casting apparaten te ontdekken wanneer je een verbinding maakt of cast.",
        "NSPhotoLibraryUsageDescription": "Toegang wordt alleen gevraagd als je zelf een afbeelding uit de app in je fotobibliotheek opslaat."
      },
      "tvos": {
        "NSLocalNetworkUsageDescription": "Deze tv maakt zichzelf kenbaar op het lokale netwerk zodat de companion-app hem kan vinden om te koppelen.",
        "NSBluetoothAlwaysUsageDescription": "Bluetooth kan worden gebruikt in combinatie met het lokale netwerk om nabijgelegen televisies en casting apparaten te ontdekken wanneer je een verbinding maakt of cast.",
        "NSPhotoLibraryUsageDescription": "Deze app kan toegang tot je fotobibliotheek vragen om afbeeldingen te tonen die je opent of deelt."
      }
    },
    "pl": {
      "ios": {
        "NSLocalNetworkUsageDescription": "Ta aplikacja używa lokalnej sieci do odkrywania urządzeń Castowych na Twoim WiFi.",
        "NSBluetoothAlwaysUsageDescription": "Bluetooth może być używany w połączeniu z lokalną siecią do odkrywania bliskich telewizorów i urządzeń castingowych, gdy łączysz się lub castujesz.",
        "NSPhotoLibraryUsageDescription": "Dostęp jest wymagany tylko wtedy, gdy zdecydujesz się zapisać obraz z aplikacji w bibliotece zdjęć."
      },
      "tvos": {
        "NSLocalNetworkUsageDescription": "Ten telewizor rozgłasza swoją obecność w sieci lokalnej, aby aplikacja towarzysząca mogła go wykryć i sparować.",
        "NSBluetoothAlwaysUsageDescription": "Bluetooth może być używany w połączeniu z lokalną siecią do odkrywania bliskich telewizorów i urządzeń castingowych, gdy łączysz się lub castujesz.",
        "NSPhotoLibraryUsageDescription": "Ta aplikacja może uzyskać dostęp do Twojej biblioteki zdjęć, aby wyświetlać obrazy, które otwierasz lub udostępniasz."
      }
    }
  },
  "flags": {
    "multicast": true
  },
  "tvConnect": {
    "webOSApplicationId": "tv.mauna.boilerplate",
    "tizenApplicationId": "6uNcK156IM.Boilerplate"
  },
  "ios": {
    "bundleIdentifier": "com.wearetriple.kahi",
    "topShelfBundleIdentifier": "com.wearetriple.kahi.TopShelfExtension",
    "appGroup": "group.com.wearetriple.kahi",
    "googleServicesFile": "./firebase/GoogleService-Info.plist",
    "castReceiverAppId": "2E631DAE"
  },
  "tvos": {
    "bundleIdentifier": "com.wearetriple.kahi",
    "googleServicesFile": "./firebase/GoogleService-Info-tv.plist",
    "castReceiverAppId": "2E631DAE"
  },
  "android": {
    "package": "com.wearetriple.kahi",
    "googleServicesFile": "./firebase/google-services.json",
    "castReceiverAppId": "2E631DAE"
  },
  "androidtv": {
    "package": "com.wearetriple.kahi.tv",
    "googleServicesFile": "./firebase/google-services-tv.json",
    "castReceiverAppId": "2E631DAE"
  }
}
